import { generateSingleItemQuery } from '../../../application/query';
const getDataSummaryQuery = (data, isPreview, extraProps = '') => {
  if (!data) {
    return null;
  }
  const {
    getEntitySchema
  } = data;
  const {
    actions: {
      getPublished,
      get
    }
  } = getEntitySchema;
  const actionKey = isPreview ? get : getPublished || get;
  return generateSingleItemQuery(actionKey, extraProps);
};
export default getDataSummaryQuery;
//# sourceMappingURL=get-data-summary-query.js.map